var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMInicio = function SvgMInicio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29,
    fill: "none",
    viewBox: "0 0 28 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.304 6.157a.44.44 0 0 0-.605 0L3.631 15.774a.44.44 0 0 0-.135.317l-.001 9.027a1.75 1.75 0 0 0 1.75 1.75H10.5a.875.875 0 0 0 .875-.875v-7.438a.44.44 0 0 1 .438-.437h4.375a.44.44 0 0 1 .437.437v7.438a.875.875 0 0 0 .875.875h5.253a1.75 1.75 0 0 0 1.75-1.75V16.09a.44.44 0 0 0-.135-.317z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m26.847 13.97-4.091-3.914V4.117a.875.875 0 0 0-.875-.875h-2.625a.875.875 0 0 0-.875.875v1.75L15.213 2.84c-.296-.3-.737-.472-1.213-.472-.475 0-.914.172-1.21.472L1.156 13.968c-.34.328-.383.868-.073 1.223a.876.876 0 0 0 1.268.058L13.699 4.406a.44.44 0 0 1 .605 0l11.349 10.843a.875.875 0 0 0 1.235-.024c.336-.348.308-.922-.041-1.256"
  })));
};
export default SvgMInicio;